import React from 'react';
import { StyleSheet, View, TouchableWithoutFeedback } from '../base_components';

import CloseButton from '../buttons/close_button';

const styles = StyleSheet.create({
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.8)',

    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  dialogView: {
    width: '28em',
    backgroundColor: '#fefefe',
    borderWidth: '0.4em',
    borderColor: '#ccc',
    borderRadius: '1em',

    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  outside: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  close: {
    position: 'absolute',
    top: '1em',
    right: '1em',
    width: '2em',
    height: '2em',
  },
});

let g_globalDialog;

type Props = {
  style?: any;
  dialogStyle?: any;
  onClose: () => void;
};

export default class Overlay extends React.PureComponent<Props> {
  render() {
    const { style, dialogStyle, children, onClose } = this.props;

    return (
      <View style={[styles.overlay, style]}>
        <TouchableWithoutFeedback style={styles.outside} onPress={onClose} />
        <View style={[styles.dialogView, dialogStyle]}>
          {children}
          <CloseButton style={styles.close} onPress={onClose} />
        </View>
      </View>
    );
  }
}
